export default function() {
  return [
    {
      title: "Dashboard",
      htmlBefore: '<i class="material-icons">dashboard</i>',
      to: "/dashboard",
      role: "admin",
    },
    {
      title: "Simple Users",
      htmlBefore: '<i class="material-icons">person</i>',
      to: "/newUsers",
      role: "admin",
    },
    {
      title: "Users",
      to: "/users",
      htmlBefore: '<i class="material-icons">person</i>',
      role: "admin",
    },

    {
      title: "Starred Users",
      to: "/starred-users",
      htmlBefore: '<i class="material-icons">person</i>',
      role: "admin",
    },
    {
      title: "Deleted Users",
      to: "/deleted-users",
      htmlBefore: '<i class="material-icons">person</i>',
      role: "admin",
    },
    {
      title: "Device Data",
      to: "/device-data",
      htmlBefore: '<i class="material-icons">smartphone</i>',
      role: "admin",
    },
    {
      title: "Sub Admins",
      to: "/sub-admins",
      htmlBefore: '<i class="material-icons">person</i>',
      role: "admin",
    },
    {
      title: "Students",
      to: "/students",
      htmlBefore: '<i class="material-icons">person</i>',
      role: "admin",
    },
    {
      title: "Settings",
      htmlBefore: '<i class="material-icons">settings</i>',
      to: "/settings",
      role: "admin",
    },
    // {
    //   title: "Dashboard",
    //   htmlBefore: '<i class="material-icons">dashboard</i>',
    //   to: "/dashboard",
    //   role:'sub-admin'
    // },
    {
      title: "Students",
      htmlBefore: '<i class="material-icons">person</i>',
      to: "/users",
      role: "sub-admin",
    },
    {
      title: "Reminder List",
      htmlBefore: '<i class="material-icons">person</i>',
      to: "/reminder-list",
      role: "sub-admin",
    },
    {
      title: "Students",
      htmlBefore: '<i class="material-icons">person</i>',
      to: "/students",
      role: "teacher",
    },
    {
      title: "Patients",
      htmlBefore: '<i class="material-icons">person</i>',
      to: "/users",
      role: "optician",
    },
  ];
}
